import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { WhatIsNewModalContext } from './WhatIsNewModalProvider';

interface WhatIsNewContentSlideProps {
  index: number;
}
const WhatIsNewButtonControlCore: React.FC<WhatIsNewContentSlideProps> = ({
  index,
}) => {
  const {
    onClickSkip,
    onGetStarted,
    onClickBack,
    onClickNext,
    onClickFinish,
    data,
    settingLoading,
  } = useContext(WhatIsNewModalContext);
  return (
    <div>
      <ButtonArea>
        {index === 0 && (
          <FormSubmitButton
            className='clear width-195'
            onClick={onClickSkip}
            btnType='button'
            loading={settingLoading}
          >
            Skip
          </FormSubmitButton>
        )}

        {index === 0 && (
          <FormSubmitButton onClick={onGetStarted} className='width-195'>
            Get Started
          </FormSubmitButton>
        )}

        {index > 1 && index < data.length - 1 && (
          <FormSubmitButton
            className='clear width-195'
            onClick={onClickBack}
            btnType='button'
          >
            Back
          </FormSubmitButton>
        )}

        {index > 0 && index < data.length - 1 && (
          <FormSubmitButton onClick={onClickNext} className='width-195'>
            Next
          </FormSubmitButton>
        )}

        {index === data.length - 1 && (
          <FormSubmitButton
            onClick={onClickFinish}
            className='width-195'
            loading={settingLoading}
          >
            Finish
          </FormSubmitButton>
        )}
      </ButtonArea>
    </div>
  );
};

const WhatIsNewButtonControl = () => {
  const { activeSliderIndex } = useContext(WhatIsNewModalContext);
  return <WhatIsNewButtonControlCore index={activeSliderIndex} />;
};

export default WhatIsNewButtonControl;

const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  width: fit-content;

  @media (max-width: 480px) {
    width: 100%;
  }
`;
